import React from 'react';

import { MenuItem } from '@mui/material';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { prepareVersionSelectTitle } from 'components/common/TreeProgramFilter/VersionSelect/versionSelect.utils';
import classes from 'components/common/VersionCompareSelectorSection/VersionCompareSelector/versionCompareSelector.module.scss';
import { IProgramVersion } from 'components/common/VersionCompareSelectorSection/VersionCompareSelectorWrapper/VersionCompareSelectorWrapper';
import { Button, CustomizedDropdownMenu, CustomizedTooltip } from 'components/common/index';

interface VersionCompareSelectorProps {
    versionsList?: IProgramVersion[];
    onVersionSelect: (version: IProgramVersion) => void;
    selectedItem: string;
    isLoading: boolean;
}

const SelectedTitle = ({ value }) => {
    return (
        <>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Top}
                tooltipContent={value}
                triggerElement={
                    <Button
                        data-testid={'compare-to'}
                        variant={'secondary'}
                        endIcon={<MuiIcon icon={'keyboard_arrow_down'} color={'inherit'} />}
                        startIcon={<MuiIcon icon={'difference'} type={'outlined'} color={'inherit'} />}
                    >
                        Compare to: {value}
                    </Button>
                }
            />
        </>
    );
};

export const NotMemoizedVersionCompareSelector = ({
    versionsList,
    onVersionSelect,
    selectedItem,
    isLoading,
}: VersionCompareSelectorProps) => {
    const selected = versionsList?.find((i) => i.versionHashCode === Number(selectedItem));

    return isLoading ? null : (
        <div className={classes.versionCompareSelector}>
            {/*<span className={classes.selectedTitle}>Compare to: </span>*/}
            <CustomizedDropdownMenu
                triggerElement={
                    <SelectedTitle
                        value={
                            versionsList && versionsList.length ? prepareVersionSelectTitle(selected) : 'No versions'
                        }
                    />
                }
            >
                {versionsList?.map((item: IProgramVersion, index) => {
                    return (
                        <MenuItem onClick={() => onVersionSelect(item)} key={index}>
                            {prepareVersionSelectTitle(item)}
                        </MenuItem>
                    );
                })}
            </CustomizedDropdownMenu>
        </div>
    );
};

export const VersionCompareSelector = React.memo(NotMemoizedVersionCompareSelector);
